import { BASE_PROD_API_URL, BASE_STG_API_URL } from '@/env.config'
import axios from 'axios'

export const getData = async (endpoint, method = 'GET', body) => {
    const isProd = ['localhost','staging'].findIndex(e => location.origin.includes(e)) < 0
    const BASE_API_URL = isProd ? BASE_PROD_API_URL : BASE_STG_API_URL
    const hasQryStr = endpoint.indexOf('?') > 0 ? '&' : '?'
    const url = `${BASE_API_URL}/${endpoint}${hasQryStr}ds=${Date.now()}`

    if(method === 'GET') {
        const resp = await axios.get(url)
        return resp.data
    } else if(method === 'DELETE') {
        const resp = await axios.delete(url)
        return resp.data
    } else {
        const data = JSON.stringify(body)
        const resp = await axios.request(
            {
                method,
                url,
                data,
                maxBodyLength: Infinity,
                headers: {
                    'Accept': 'application/json',  
                    'Content-Type': 'application/json'
                }
            }
        )
        return resp?.data || ''
    }
}